export { default, links, meta } from "/Users/brandonklise/src/hosting/cloud/terraform/cloudflare/jsonhero2/jsonhero-web/app/routes/privacy.mdx";